import { render, staticRenderFns } from "./LeadChatMessages.vue?vue&type=template&id=3ff4feec"
import script from "./LeadChatMessages.vue?vue&type=script&lang=js"
export * from "./LeadChatMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports